import { Modal } from 'antd'
import approveImg from 'components/Images/duplicate.png'
import React from 'react'
import ApprovedIcon from 'components/icons/ApprovedIcon'
import styled, { createGlobalStyle } from 'styled-components'

const SuccessModalStyle = createGlobalStyle`
  .success-modal .ant-modal-content {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
  }

  .success-modal .ant-modal-body {
    padding: 0 !important;
  }
`

const SuccessPopup = styled.div`
  width: 763px;
  height: 405px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 1px 2px 0px #1018280D;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`

const SuccessIcon = styled.div`
  width: 80px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(8px);
`

const SuccessText = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  width: auto;
  height: 21px;
  color: #343E59;
`

const SuccessCloseButton = styled.button`
width: 80;
height: 38;
angle: 0 deg;
opacity: 1;
top: 252px;
left: 341px;
border-width: 1px;
border-radius: 10px;
padding-top: 9px;
padding-right: 20px;
padding-bottom: 9px;
padding-left: 20px;
gap: 7px;
background: #FBFAFF;
color: #3249D7;
border: 1px solid #E3DEFF
`

const SuccessPopupModal = ({
  open,
  onClose,
  loading = false,
}) => {
  return (
    <Modal
      open={open}
      footer={null}
      centered
      closable={false}
      className="success-modal"
    >
      <SuccessModalStyle />

      <SuccessPopup>
        <SuccessIcon>
          <ApprovedIcon width={80} height={68} />
        </SuccessIcon>

        <SuccessText>Changes Approved</SuccessText>

        <SuccessCloseButton
          style={{ cursor: 'pointer' }}
          onClick={onClose}
          disabled={loading}
        >
          Close
        </SuccessCloseButton>
      </SuccessPopup>
    </Modal>
  )
}
 export default SuccessPopupModal